import { useContext } from "react";
import { AppContext } from "../apollo/wrap-root-element";

// Custom hook
export const useCurrentUser = () => {
  const { currentUserDetails } = useContext(AppContext);

  const isLoggedIn = Boolean(currentUserDetails?.customer);
  
  return {
    currentUserDetails,
    isLoggedIn,
  };
};
